import React from 'react';
import { Link } from 'react-router-dom';

const CustomBusinessSupport = () => {
  return (
    <div className='text-xs lg:text-[13px] mb-[25px]'>
      <p>
        <b>{`Do you need to make any changes to your business/company registration with CAC or file annual returns?`}</b>
        <br />
        <p className='my-2'>{`We've got you covered at The Business Hub - from generating Tax Identification Number to upgrading your business registration category to changing your shareholders details to filing annual returns.`}</p>
        <br />
        {`Let's help you handle them while you focus on your business. The best part?`}
      </p>
      <ul className='list-disc my-3'>
        {['No Paper work', 'Quick processing'].map((item) => (
          <li className='mt-1' key={item}>
            {item}
          </li>
        ))}
      </ul>
      <div>
        Please fill this
        <Link to={'/Postincorportationservice'}>
          <span className='decoration-solid text-[blue] !text-[15px] font-[500]'>{` FORM `}</span>
        </Link>
        and indicate the service you are interested in and one of our agents would contact you to
        begin the process.
      </div>
    </div>
  );
};

export default CustomBusinessSupport;
